
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as exposed from '../exposed'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Request} from '../core/Request';
import {FieldModelRequest} from '../core/Request';
import {AuthTokensDeleteResponse} from './AuthTokensDeleteResponse';

/**
 * AuthTokensDeleteRequest struct
 */
class AuthTokensDeleteRequest extends Request {
  /**
   * Initialize struct
   * @param {!Request=} parent
   * @param {!Array=} tokenIds
   * @constructor
   */
  constructor (parent = new Request(), tokenIds = []) {
    super()
    super.copy(parent)
    this.TokenIds = tokenIds
  }

  /**
   * Copy struct (shallow copy)
   * @this {!AuthTokensDeleteRequest}
   * @param {!AuthTokensDeleteRequest} other Other struct
   * @returns {!AuthTokensDeleteRequest} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.TokenIds != null) {
      this.TokenIds = []
      for (let item of other.TokenIds) {
        if (item != null) {
          let tempItem
          tempItem = UInt64.fromNumber(item)
          this.TokenIds.push(tempItem)
        } else {
          this.TokenIds.push(null)
        }
      }
    } else {
      this.TokenIds = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!AuthTokensDeleteRequest}
   * @returns {!AuthTokensDeleteRequest} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new AuthTokensDeleteRequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new AuthTokensDeleteRequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!AuthTokensDeleteRequest}
   * @param {!AuthTokensDeleteRequest} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof AuthTokensDeleteRequest)) {
      throw new TypeError('Instance of AuthTokensDeleteRequest is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!AuthTokensDeleteRequest}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      TokenIds: ((this.TokenIds != null) ? Array.from(this.TokenIds, item => ((item != null) ? item.toNumber() : null)) : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return AuthTokensDeleteRequest.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!AuthTokensDeleteRequest} other Object value
   * @returns {!AuthTokensDeleteRequest} Created struct
   */
  static fromObject (other) {
    return new AuthTokensDeleteRequest().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!AuthTokensDeleteRequest}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return AuthTokensDeleteRequest.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!AuthTokensDeleteRequest}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 5547
  }
}

export { AuthTokensDeleteRequest };

/**
 * Fast Binary Encoding AuthTokensDeleteRequest field model
 */
class FieldModelAuthTokensDeleteRequest extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelRequest(buffer, 4 + 4)
    this.TokenIds = new fbe.FieldModelVector(new fbe.FieldModelUInt64(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
  }

  /**
   * Get the core.Request field model
   * @this {!FieldModelAuthTokensDeleteRequest}
   * @returns {!FieldModelRequest} core.Request field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelAuthTokensDeleteRequest}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelAuthTokensDeleteRequest}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.TokenIds.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelAuthTokensDeleteRequest}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.TokenIds.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelAuthTokensDeleteRequest}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelAuthTokensDeleteRequest.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelAuthTokensDeleteRequest}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 5547
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelAuthTokensDeleteRequest}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelAuthTokensDeleteRequest}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.TokenIds.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.TokenIds.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TokenIds.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelAuthTokensDeleteRequest}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelAuthTokensDeleteRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelAuthTokensDeleteRequest}
   * @param {!AuthTokensDeleteRequest} fbeValue Default value, defaults is new AuthTokensDeleteRequest()
   * @returns {!AuthTokensDeleteRequest} AuthTokensDeleteRequest value
   */
  get (fbeValue = new AuthTokensDeleteRequest()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelAuthTokensDeleteRequest}
   * @param {!AuthTokensDeleteRequest} fbeValue AuthTokensDeleteRequest value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.TokenIds.fbeSize) <= fbeStructSize) {
      this.TokenIds.get(fbeValue.TokenIds)
    } else {
      fbeValue.TokenIds.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TokenIds.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelAuthTokensDeleteRequest}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelAuthTokensDeleteRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelAuthTokensDeleteRequest}
   * @param {!AuthTokensDeleteRequest} fbeValue AuthTokensDeleteRequest value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelAuthTokensDeleteRequest}
   * @param {AuthTokensDeleteRequest} fbeValue AuthTokensDeleteRequest value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.TokenIds.set(fbeValue.TokenIds)
  }
}

export { FieldModelAuthTokensDeleteRequest };

/**
 * Fast Binary Encoding AuthTokensDeleteRequest model
 */
class AuthTokensDeleteRequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelAuthTokensDeleteRequest(this.buffer, 4)
  }

  /**
   * Get the AuthTokensDeleteRequest model
   * @this {!AuthTokensDeleteRequestModel}
   * @returns {!FieldModelAuthTokensDeleteRequest} model AuthTokensDeleteRequest model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!AuthTokensDeleteRequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!AuthTokensDeleteRequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return AuthTokensDeleteRequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!AuthTokensDeleteRequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelAuthTokensDeleteRequest.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!AuthTokensDeleteRequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!AuthTokensDeleteRequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!AuthTokensDeleteRequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!AuthTokensDeleteRequestModel}
   * @param {!AuthTokensDeleteRequest} value AuthTokensDeleteRequest value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!AuthTokensDeleteRequestModel}
   * @param {!AuthTokensDeleteRequest} value AuthTokensDeleteRequest value, defaults is new AuthTokensDeleteRequest()
   * @return {!object} Deserialized AuthTokensDeleteRequest value and its size
   */
  deserialize (value = new AuthTokensDeleteRequest()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new AuthTokensDeleteRequest(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new AuthTokensDeleteRequest(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!AuthTokensDeleteRequestModel}
   * @param {!number} prev Previous AuthTokensDeleteRequest model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { AuthTokensDeleteRequestModel };
AuthTokensDeleteRequest.__has_response = true;
AuthTokensDeleteRequest.__response_class = AuthTokensDeleteResponse;
